module.exports = __webpack_public_path__ + "img/29.bbac47e4.jpg";